import { render, staticRenderFns } from "./PointOfInterestCard.vue?vue&type=template&id=1f85bf54&scoped=true&"
import script from "./PointOfInterestCard.vue?vue&type=script&lang=js&"
export * from "./PointOfInterestCard.vue?vue&type=script&lang=js&"
import style0 from "./PointOfInterestCard.vue?vue&type=style&index=0&id=1f85bf54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f85bf54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VSpacer})
